import React from 'react';

const TabBar = ({ items = [], selected = 0, onTabChange }) => (
  <ul className="c-TabBar">
    {items.map((item, idx) => (
      <li className="c-TabBar__item" key={idx}>
        <button
          className={selected === idx ? "c-TabBar--selected c-TabBar__button" : "c-TabBar__button"}
                onClick={() => onTabChange(idx)}
        >
          {item.title}
        </button>
      </li>
    ))}
  </ul>
);

export default TabBar



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/officetabs/js/TabBar.js